export const state = {
    portadorFinanceiro: {},
    portadoresFinanceiro: [],
    modalExcluirPortadorFinanceiro: false,
    modalCadastroPortadorFinanceiro: false,
    modalListarPortadorFinanceiro: false
}

export default {}